import EditorMain from "../../../components/EditorMain";
import tradoEditorConfig from "../utils/tradoEditorConfig";
import useTradoEditorTrailerDialogs from "../hooks/header/useTradoEditorTrailerDialogs";
import useTradoEditorValidation from "../hooks/validation/useTradoEditorValidation";
import TradoEditorHeaderTopRows from "./header/TradoEditorHeaderTopRows";
import TradoEditorTrailerDialogs from "./dialogs/TradoEditorTrailerDialogs";
import TradoEditorTrailerCheckList from "./checklist/TradoEditorTrailerCheckList";
import TradoEditorFotoSections from "./foto/TradoEditorFotoSections";

// Everything that makes the trado editor different from the mobil editor.
// The page itself is the shared EditorMain (features/cek-keluar-masuk/components).
const tradoEditorVariant = {
  config: tradoEditorConfig,
  useTrailerDialogs: useTradoEditorTrailerDialogs,
  useValidation: useTradoEditorValidation,
  HeaderTopRows: TradoEditorHeaderTopRows,
  TrailerDialogs: TradoEditorTrailerDialogs,
  TrailerCheckList: TradoEditorTrailerCheckList,
  FotoSections: TradoEditorFotoSections,

  // trado: every signature box validates before verifying
  buildSignatureValidators: (validation) => {
    const validateBerangkat = () =>
      validation.handleValidateVerifikasi("berangkat");
    const validateKembali = () =>
      validation.handleValidateVerifikasi("kembali");
    return {
      onValidateStaffBerangkat: validateBerangkat,
      onValidateKeamananBerangkat: validateBerangkat,
      onValidateStaffKembali: validateKembali,
      onValidateKeamananKembali: validateKembali,
    };
  },
};

const CekKeluarMasukTradoEditorMain = () => {
  return <EditorMain variant={tradoEditorVariant} />;
};

export default CekKeluarMasukTradoEditorMain;
